module.exports = __webpack_public_path__ + "static/img/1_1_1.844b80f2.jpg";